module.exports = __webpack_public_path__ + "static/media/logo.3db46c21.svg";